import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { ErrorWrapper, ErrorMessage } from "src/react/components/error-message";
import {
  cardErrorMessages,
  cardErrorDefaultMessage,
} from "src/data/card-error-messages";
import { A } from "src/react/components/link";

export function DefaultErrorMessage({ message }) {
  return message || cardErrorDefaultMessage;
}

export default function PaymentErrorMessage({ error = {}, defaultMessage }) {
  const errorMessage = error ? error["error-message"] : "";
  const cardErrorMessage = cardErrorMessages[errorMessage];
  return (
    <ErrorWrapper data-selector="PaymentErrorMessage">
      <ErrorMessage>
        {cardErrorMessage ? (
          <Fragment>
            <p>{cardErrorMessage}</p>
            <p>
              Please{" "}
              <A href="mailto:help@cornerstone.co.uk">email customer service</A>{" "}
              if you still have a problem with your payment details.
            </p>
          </Fragment>
        ) : (
          <DefaultErrorMessage message={defaultMessage} />
        )}
      </ErrorMessage>
    </ErrorWrapper>
  );
}
PaymentErrorMessage.propTypes = {
  error: PropTypes.shape({
    "error-message": PropTypes.string,
  }),
  defaultMessage: PropTypes.any,
};
